<nb-card>
  <nb-card-header>{{ title }}</nb-card-header>
  <nb-card-body style="width: 400px;">
    <div class="row" *ngFor="let col of dataSource">
      <div class="col" *ngFor="let item of col.columns" style="margin-bottom: 5px;">
        <mat-label class="sub-title text-primary">{{item.titulo}}</mat-label>
        <br>
        <span *ngIf="!item.formatDate">{{item.valor}} </span>
        <span *ngIf="item.formatDate">{{item.valor | date: item.formatDate}} </span>
      </div>
    </div>


    <!-- Datos Extras para Detalles de Eventos -->
    <div *ngIf="dataEvento">
      <div class="row" *ngIf="dataEvento.datos && claves">
        <div class="col-12">
          <mat-card>
            <mat-card-header class="bg-primary text-white">
              <mat-card-title>DATOS DE LA TRANSACCION</mat-card-title>
            </mat-card-header>

            <mat-card-content>
              <mat-list *ngFor="let clave of claves; let detail of dataEvento.datos">
                <mat-list-item>
                  <h3 matLine>{{clave}}</h3>
                  <p matLine class="text-primary">{{dataEvento.datos[clave]}}</p>
                </mat-list-item>
              </mat-list>
            </mat-card-content>
          </mat-card>
        </div>
      </div>

      <div class="row" *ngIf="dataEvento.recursoAntes || dataEvento.recursoDespues">
        <div class="col-12" *ngIf="dataEvento.recursoAntes">
          <mat-card>
            <mat-card-header class="bg-danger text-white">
              <mat-card-title>ANTES</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              {{dataEvento.recursoAntes | json}}
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-12" *ngIf="dataEvento.recursoDespues">
          <mat-card>
            <mat-card-header class="bg-primary text-white">
              <mat-card-title>DESPU&Eacute;S</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              {{dataEvento.recursoDespues | json}}
            </mat-card-content>
          </mat-card>
        </div>
      </div>

    </div>
  </nb-card-body>
  <nb-card-footer>
    <div class="modal-footer">
      <button nbButton matRipple status="warning" (click)="dismiss()">{{button}}</button>
    </div>
  </nb-card-footer>
</nb-card>